<template>
  <div class="h-100">
    <div class="loader-cont" v-dxloader="isLoader"></div>
    <div class="row h-100" v-show="!isLoader">
      <div class="content-wrapper-before gradient-45deg-indigo-purple"></div>
      <div class="breadcrumbs-dark pb-0 pt-4" id="breadcrumbs-wrapper">
        <div class="container">
          <div class="row">
            <div class="col s10 m6 l6 alignLeft">
              <h5 class="card-title alignLeft white-text">FAQ's</h5>
            </div>
            <div class="col s10 m6 l6 alignRight">
              <a @click="preAddFaq" class="btn add_btn modal-trigger" data-target="modal-faq">
                <span>Add FAQ</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="col s12 p-0" style="height:calc(100% - 45px)">
        <div class="container p-0 h-100">
          <div class="section p-0 h-100" id="faq">
            <div class="row m-0 h-100">
              <div class="col s12 m12 l12 p-0 h-100">
                <div id="responsive-table" class="card card card-default scrollspy p-0 h-100">
                  <div class="card-content h-100">
                    <div class="row">
                      <div class="search-input col s8 m5 l5">
                        <div class="sidebar-search animate fadeUp">
                          <div class="search-area">
                            <i class="material-icons mr-2 search-icon">search</i>
                            <i
                              class="material-icons mr-2 close-icon"
                              v-show="search"
                              @click="search=''"
                            >close</i>
                            <input
                              v-model="search"
                              placeholder="Start typing your search..."
                              id="search"
                              type="text"
                              class="app-filter"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="faq row"
                      style="height: calc(100% - 56px); overflow-y: auto;"
                      :class="{'bgwhite' : faqList.length==0}"
                    >
                      <div class="col s12 m12 l12 h-100">
                        <ul class="collapsible categories-collapsible">
                          <li v-for="(item,index) in faqList" :key="index" class>
                            <div class="collapsible-header" tabindex="0">
                              Q: {{item.title}}
                              <i class="material-icons">keyboard_arrow_right</i>
                            </div>
                            <div class="collapsible-body" style>
                              <div class="descs" v-html="item.description"></div>
                              <div class="footer-cls">
                                <button
                                  data-target="modal-faq"
                                  @click="updateFaq(item)"
                                  class="modal-trigger pointer waves-effect btn-flat btn-cls"
                                >Edit</button>
                                <button
                                  @click="deleteFaq(item)"
                                  class="pointer waves-effect btn-flat btn-cls"
                                >Delete</button>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="modal-faq" class="modal">
      <div class="modal-header header_br">
        <h6 class="alignLeft">{{isEdit ? 'Update' : 'Add'}} FAQ</h6>
      </div>
      <form class="login-form">
        <div class="modal-content">
          <div class="row">
            <div class="col s12 m12 l12">
              <div class="row margin">
                <div class="input-field col s12">
                  <textarea
                    class="materialize-textarea"
                    data-length="250"
                    v-model="currFaq.title"
                    id="title"
                    name="title"
                    type="text"
                  ></textarea>
                  <label for="title" class="center-align">Title</label>
                  <div class="error-message" v-if="nameErr">{{nameErr}}</div>
                </div>
              </div>
              <div class="row margin">
                <div class="input-field col s12 faq">
                  <label for="description" class="center-align">Description</label>
                  <editor
                    :init="tynyInitObj"
                    api-key="0v0a5m4g0aiec6pr65g9jrr231ojdi4wl36sms4rnczgcof6"
                    v-model="currFaq.description"
                  ></editor>
                  <div class="error-message" v-if="descErr">{{descErr}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <a class="modal-action modal-close waves-effect btn-flat">Cancel</a>
          <button
            v-loader-button="isLoading"
            @click="submit()"
            type="submit"
            name="action"
            class="pointer waves-effect btn"
          >Save</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
window.editor = Editor;
export default {
  data() {
    return {
      currFaq: {},
      faqList: [
        {
          id: 1,
          description:
            "If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet.",
          title: "Do memberships include the original PSD files?"
        },
        {
          id: 2,
          description:
            "If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet.",
          title: "Do memberships include the original PSD files?"
        },
        {
          id: 3,
          description:
            "If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet.",
          title: "Do memberships include the original PSD files?"
        },
        {
          id: 4,
          description:
            "If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet.",
          title: "Do memberships include the original PSD files?"
        }
      ],
      Validator: {},
      isEdit: false,
      nameErr: "",
      descErr: "",
      search: "",
      isLoader: false,
      isLoading: false,
      tynyInitObj: {
        menubar: false,
        height: 300,
        plugins: [
          "advlist autolink lists link image charmap print preview anchor",
          "searchreplace visualblocks code fullscreen",
          "insertdatetime media table paste code help wordcount"
        ],
        toolbar:
          "undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help",
        oninit: this.onInit()
      }
    };
  },
  created() {
    setTimeout(() => {
      $(".modal").modal({ dismissible: false });
      // $("textarea").characterCounter();
      // $('.jqte_editor').on('keyup',(e)=>{
      //     if(!$(e.target).text()){
      //         this.descErr = "Description is required.";
      //     }else{
      //         this.descErr = "";
      //     }
      // })
    }, 700);
    this.listFAQ();
    setTimeout(() => {
      this.Validator = $(".login-form").validate({
        rules: {
          description: {
            required: true
          },
          title: {
            required: true
          }
        },
        errorElement: "div",
        errorPlacement: function(error, element) {
          var placement = $(element).data("error");
          if (placement) {
            $(placement).append(error);
          } else {
            error.insertAfter(element);
          }
        },
        submitHandler: e => {
          setTimeout(() => {
            if (this.currFaq.id) {
              this.confirmUpdate();
            } else {
              this.confirmAdd();
            }
          }, 500);
          return false;
        }
      });
    }, 500);
  },
  components: {
    editor: window.editor
  },
  methods: {
    onInit() {
      console.log("tinymce created");
    },
    listFAQ(q = "") {
      ajax.get(
        Constants.default.APIURL.FAQ + "?q=" + q,
        res => {
          this.faqList = res.data;
          this.isLoader = false;
          setTimeout(() => {
            $(".collapsible").collapsible({
              accordion: true,
              onOpenStart: function() {
                $(".collapsible > li.open").removeClass("open");
                setTimeout(function() {
                  $("#slide-out > li.active > a")
                    .parent()
                    .addClass("open");
                }, 10);
              }
            });
          }, 700);
          if (this.faqList.length == 0) {
            Vue.showNoDataBlock(".faq");
          } else {
            Vue.hideNoDataBlock(".faq");
          }
        },
        err => {
          this.isLoader = false;
        }
      );
    },
    updateFaq(item) {
      this.isEdit = true;
      this.nameErr = "";
      this.descErr = "";

      this.currFaq = {
        id: item.id,
        title: item.title,
        description: item.description
      };
      this.currFaq.description = item.description;
      setTimeout(() => {
        this.Validator.resetForm();
        M.updateTextFields();
      }, 200);
    },
    preAddFaq() {
      this.currFaq = {};
      this.isEdit = false;
      this.nameErr = "";
      this.descErr = "";
      this.currFaq.description = "";
      setTimeout(() => {
        this.Validator.resetForm();
        M.updateTextFields();
      }, 100);
    },
    deleteFaq(item) {
      this.currFaq = {
        id: item.id,
        title: item.title,
        description: item.description
      };
      swal({
        title: "Are you sure?",
        text: "You will not be able to recover it!",
        icon: "warning",
        dangerMode: true,
        buttons: {
          cancel: true,
          delete: "Yes, Delete It"
        }
      }).then(willDelete => {
        if (willDelete) {
          this.confirmDelete();
        }
      });
    },
    confirmUpdate() {
      if (!tinyMCE.activeEditor.plugins.wordcount.getCount()) {
        this.descErr = "Description is required.";
        return;
      }
      let query = {
        title: this.currFaq.title,
        description: this.currFaq.description
      };
      this.isLoading = true;
      ajax.patch(
        Constants.default.APIURL.FAQ + this.currFaq.id + "/",
        query,
        res => {
          this.isLoading = false;
          $(".modal").modal("close");
          this.currFaq = {};
          this.isEdit = false;
          this.nameErr = "";
          this.descErr = "";
          this.currFaq.description = "";
          Vue.toast("Faq was updated successfully.");
          this.listFAQ();
        },
        err => {
          this.isLoading = false;
          this.handleError(err);
        }
      );
    },
    confirmDelete() {
      this.isLoading = true;
      ajax.delete(
        Constants.default.APIURL.FAQ + this.currFaq.id + "/",
        {},
        res => {
          this.isLoading = false;
          this.listFAQ();
          Vue.toast("Faq has been deleted!");
        },
        err => {
          this.isLoading = false;
          let errorMsg = Vue.errorHandler(err);
          Vue.toast(errorMsg);
        }
      );
    },
    confirmAdd() {
      if (!tinyMCE.activeEditor.plugins.wordcount.getCount()) {
        this.descErr = "Description is required.";
        return;
      }
      this.isLoading = true;
      let query = {
        title: this.currFaq.title,
        description: this.currFaq.description
      };
      ajax.post(
        Constants.default.APIURL.FAQ,
        query,
        res => {
          this.isLoading = false;
          $(".modal").modal("close");
          Vue.toast("Faq was added successfully.");
          this.listFAQ();
        },
        err => {
          this.isLoading = false;
          this.handleError(err);
        }
      );
    },
    handleError(err) {
      let errorMessage = "";
      if (err.status == 400) {
        if (err.data) {
          if (err.data.non_field_errors) {
            errorMessage = err.data.non_field_errors[0];
            Vue.toast(errorMessage);
          } else {
            if (Object.keys(err.data).length > 0) {
              this.nameErr = err.data["title"] ? err.data["title"][0] : "";
            }
          }
        } else {
          if (err.non_field_errors) {
            errorMessage = err.non_field_errors[0];
            Vue.toast(errorMessage);
          } else {
            if (Object.keys(err).length > 0) {
              if (Object.keys(err.data).length > 0) {
                this.nameErr = err.data["title"] ? err.data["title"][0] : "";
              }
            }
          }
        }
        errorMessage = errorMessage ? errorMessage : "Something went wrong.";
      } else if (err.status == 401) {
      } else {
      }
    },
    submit() {
      if (!this.currFaq.description) {
        this.descErr = "Description is required.";
      } else {
        this.descErr = "";
      }
    }
  },
  watch: {
    search: function() {
      this.listFAQ(this.search);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./../../public/assets/css/pages/page-faq.css";
@import "./../../public/assets/vendors/sweetalert/sweetalert.css";
.footer-cls {
  padding: 10px;
  text-align: right;
}
.input-field {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}
.bgwhite {
  background: white !important;
  .nodata {
    img {
      width: 40% !important;
    }
  }
}

.add_btn {
  bottom: 40px;
  right: 20px;
}

.minht-50 {
  min-height: 60px;
}

.descs {
  display: inline-block;
  word-break: break-all;
  width: 100%;
  padding-right: 40px;
  text-align: left;
}

.error-message {
  text-align: right !important;
  margin-top: -10px !important;
}
.search-area {
  .app-filter {
    height: 35px;
    margin-bottom: 0;
    padding: 0.2rem;
    color: #183247;
    border: none;
    border-radius: 5px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    background-color: #eceff1;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    border-bottom: 0 !important;
    box-shadow: none !important;
  }
}
#faq {
  .categories-collapsible {
    border: none;
    li {
      border: 1px solid #eceff1;
      margin-bottom: 10px;
      &.active {
        border: none;
        .collapsible-header {
          margin: 0;
          border: 1px solid #eceff1;
        }
        .collapsible-body {
          padding-top: 0.5rem;
          border: 1px solid #eceff1;
          border-top: none;
        }
        button {
          font-size: 1rem;
          line-height: 32.4px;
          height: 32.4px;
          &.modal-trigger {
            background: #efefef;
          }
        }
      }
    }
  }
}
</style>

